import React, { useState, useEffect } from 'react';
import { useApi } from '@/contexts/AuthContext';
import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { ChevronDown, ChevronUp } from 'lucide-react';

export default function ModeScenariosPage() {
  const api = useApi();
  const [scenarios, setScenarios] = useState(null);
  const [open, setOpen] = useState(0);

  useEffect(() => {
    api.get('/operating-modes').then(r => setScenarios(r.data?.scenarios || [])).catch(() => setScenarios([]));
  }, [api]);

  if (!scenarios) return <Skeleton className="h-96 rounded-sm" data-testid="scenarios-loading" />;

  return (
    <div className="space-y-3" data-testid="mode-scenarios-page">
      <p className="text-sm max-w-3xl" style={{ color: '#5C6B7A' }}>
        The sequences an MGA is actually sold — which modes are active in which week of an
        implementation, and why. Each phase names the modes it turns on.
      </p>
      {scenarios.map((sc, idx) => {
        const isOpen = open === idx;
        return (
          <Card key={idx} className="rounded-sm border border-[rgba(136,150,168,0.2)] bg-white overflow-hidden">
            <button onClick={() => setOpen(isOpen ? null : idx)} data-testid={`scenario-toggle-${idx}`}
              className="w-full p-4 flex items-center justify-between text-left hover:bg-[#F5F7FA] transition-colors">
              <div>
                <p className="text-sm font-bold" style={{ color: '#0B1E3D' }}>{sc.scenario}</p>
                <p className="text-xs mt-0.5" style={{ color: '#5C6B7A' }}>{sc.description}</p>
              </div>
              <div className="flex items-center gap-2 shrink-0 ml-4">
                <span className="text-[10px] px-2 py-0.5 rounded-sm" style={{ background: 'rgba(27,74,154,0.1)', color: '#1B4A9A' }}>
                  {sc.mode_sequence?.length} phases
                </span>
                {isOpen ? <ChevronUp className="w-4 h-4" style={{ color: '#5C6B7A' }} /> : <ChevronDown className="w-4 h-4" style={{ color: '#5C6B7A' }} />}
              </div>
            </button>
            {isOpen && (
              <div className="px-4 pb-4 border-t border-[rgba(136,150,168,0.1)]">
                <div className="mt-3 space-y-2">
                  {(sc.mode_sequence || []).map((phase, pi) => (
                    <div key={pi} className="flex gap-3 items-start" data-testid={`scenario-${idx}-phase-${pi}`}>
                      <div className="w-20 shrink-0 text-right pt-2">
                        <span className="text-xs font-mono font-bold" style={{ color: '#1B4A9A' }}>{phase.week}</span>
                      </div>
                      <div className="w-0.5 self-stretch rounded-full" style={{ background: 'rgba(27,74,154,0.35)' }} />
                      <div className="flex-1 p-3 rounded-sm" style={{ background: '#F5F7FA' }}>
                        <div className="flex flex-wrap gap-1 mb-1.5">
                          {phase.modes.map(m => (
                            <span key={m} className="text-[9px] px-1.5 py-0.5 rounded-sm font-semibold font-mono"
                              style={{ background: 'rgba(27,74,154,0.1)', color: '#1B4A9A' }}>{m}</span>
                          ))}
                        </div>
                        <p className="text-xs leading-relaxed" style={{ color: '#5C6B7A' }}>{phase.rationale}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </Card>
        );
      })}
    </div>
  );
}
